import { useMediaQuery } from '@mui/material';

export const useDevice = () => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const isDesktop = useMediaQuery('(min-width: 1200px)');
  const isTablet = !isMobile && !isDesktop;

  return { isMobile, isTablet, isDesktop };
};
